module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAA6klEQVQ4jdXUsUoEMRCA4W9lFUUU7g2sBV/hsPA5DrW2sFCw9EUsRJDrrrKw2UJOsLAXBLEWLGy1cC2ygbgm6tn5Q4oZJn8ySXardjiUYRcnvdwIZ/3COjcbF9jp5S5zhTUmGBREKduZ3HONB2xhHee/EKU81TjAMdYKq+RYxCvauRlXjNwJB60kWBVaimxgJYkHMS4J9tAkcePrrfhOsCD0GZkv1f71DP6B4L0bkbYkKH0LYzwm8T6uZxHcdyNyWtpBbOGtk1WlwoRKuOZPO7jBsvAPuPph8iaWcJsKGhx1I/viEl5wiCl8AJmpIpE7jAOiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/delete.png
// module id = vmxF
// module chunks = 2